import { render, staticRenderFns } from "./PaymentsPanel.vue?vue&type=template&id=6e445c50"
import script from "./PaymentsPanel.vue?vue&type=script&lang=js"
export * from "./PaymentsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports